import { render, staticRenderFns } from "./AnalyticsSimpleTable.vue?vue&type=template&id=6550d663&scoped=true&"
import script from "./AnalyticsSimpleTable.vue?vue&type=script&lang=js&"
export * from "./AnalyticsSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsSimpleTable.vue?vue&type=style&index=0&id=6550d663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550d663",
  null
  
)

export default component.exports